import { createFileRoute } from "@tanstack/react-router";

import { LinkAccessView } from "@/components/LinkAccessView";

// Public route. No AuthGate - the link token is itself the grant,
// and signed-out visitors must be able to reach this view. Owner
// self-redirect to /folder/{parent} is handled inside the view so
// authenticated users still see the public page briefly while we
// resolve ownership - that's intentional: the link-access page is
// the source of truth about the share, not a client-side guess.
export const Route = createFileRoute("/links/$token")({
  component: function LinkAccessPage() {
    const { token } = Route.useParams();
    return <LinkAccessView token={token} />;
  },
});
